(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["gallery-images"]) return;
  try {
    
	
	//LIGHTBOX FUNCTION
	var lbCnt = $("#lb-cnt");
	var galleryWrap = $("#gallery-images-wrap");

	//Add image to lb on hover
	$(".gallery-item").hover(function() {//console.log("hover");
			var thisIndex = $(this).index();
			var clone = $(this).clone().attr("data-index", thisIndex);
        	lbCnt.find(".inner-wrap:not(.active):first").find(".item-wrap").empty().append(clone);
        
		},
		function() {
        	
    }); //.hover

	//Open
	$(".gallery-item").click(function() {
		var lbWrap = lbCnt.find(".inner-wrap:not(.active):first");
	
		lbWrap.addClass("active");
		lbCnt.addClass("active");

		//If there is no gallery item to show(mobile)
		if (!lbWrap.find(".gallery-item").length) {
			var thisIndex = $(this).index();
			var clone = $(this).clone().attr("data-index", thisIndex);

			lbWrap.append(clone);
		}

	}); //.click

	//Close
	$("#close-lb-btn").click(function() {

		lbCnt.find(".inner-wrap.active").removeClass("active");
		lbCnt.removeClass("active");

	}); //.click

	
	if($(window).width() > 767) {
		$("#lb-cnt .inner-wrap").click(function() {
		
			lbCnt.find(".inner-wrap.active").removeClass("active");
			lbCnt.removeClass("active");

		}); //.click
	}


	//Prev Hover
	$(".prev-btn-cnt").hover(function() {//console.log("hover");
		setPrevImg();

	},
	function() {

	}); //.hover


	//Next Hover
	$(".next-btn-cnt").hover(function() {//console.log("hover");
		setNextImg();
	},
	function() {

	}); //.hover


	//Prev Btn
	$(".prev-btn-cnt").click(function() {
		var currentActive = lbCnt.find(".inner-wrap.active");
		var nextActive = lbCnt.find(".inner-wrap:not(.active)");

		nextActive.addClass("active");
		currentActive.removeClass("active").find(".item-wrap").empty();

		setPrevImg();

	}); //.click

	
	//Next Btn
	$(".next-btn-cnt").click(function() {
		var currentActive = lbCnt.find(".inner-wrap.active");
		var nextActive = lbCnt.find(".inner-wrap:not(.active)");

		nextActive.addClass("active");
		currentActive.removeClass("active").find(".item-wrap").empty();

		setNextImg();

	}); //.click


	//Set Prev Img Function
	function setPrevImg() {
		var currentIndex = lbCnt.find(".inner-wrap.active").find(".gallery-item").attr("data-index");//console.log(currentIndex);

		//Set PrevIndex
		if (currentIndex == 0) {//console.log("cur index == 0");
			prevIndex = (galleryWrap.find(".gallery-item").length - 1);
		}
		else {//console.log("cur index != 0");
			prevIndex = --currentIndex;
		}
		//console.log("prevIndex: " + prevIndex);

		var clone = galleryWrap.find(".gallery-item").eq(prevIndex).clone().attr("data-index", prevIndex);

		lbCnt.find(".inner-wrap:not(.active):first").find(".item-wrap").empty().append(clone);
	} //setPrevImg()


	//Set Next Img Function
	function setNextImg() {
		var currentIndex = lbCnt.find(".inner-wrap.active").find(".gallery-item").attr("data-index");//console.log(currentIndex);

		//Set NextIndex
		if (currentIndex == (galleryWrap.find(".gallery-item").length - 1)) {//console.log("cur index == gallery-items.length");
			nextIndex = 0;
		}
		else {//console.log("cur index != gallery-items.length");
			nextIndex = ++currentIndex;
		}
		//console.log("nextIndex: " + nextIndex);

		var clone = galleryWrap.find(".gallery-item").eq(nextIndex).clone().attr("data-index", nextIndex);

		lbCnt.find(".inner-wrap:not(.active):first").find(".item-wrap").empty().append(clone);
	} //setPrevImg()
	

	

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-testimonials"] && !window.DesignMode) return;
  try {
    

  var $autoplaySpeed = $("#testimonials-cnt").attr("data-autoplaySpeed");//console.log($autoplaySpeed);

  //Set Initial Height
  $('#testimonials-cnt').on('init', function(event, slick) {
	var setHeight = $(this).find(".slick-slide").eq(0).outerHeight(true) + "px";//console.log(setHeight);

	$(this).find(".slick-list.draggable").css("height", setHeight);

  });

  //Resize Container for each slide
  $('#testimonials-cnt').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    var nxSlideHeight = $(this).find(".slick-slide").eq(nextSlide).outerHeight(true);//console.log(nxSlideHeight);
	nxSlideHeight = nxSlideHeight + "px";//console.log(nxSlideHeight);

	$(this).find(".slick-list.draggable").animate({height: nxSlideHeight}, 500);
  });


  $('#testimonials-cnt').slick({
    dots: true,
    infinite: true,
    slidesToShow: 1,
    speed: 500,
    autoplay: true,
    autoplaySpeed: $autoplaySpeed,
    fade: true,
    cssEase: 'linear'
  });


  } catch(e) { console.error(e); }
})();
      })();
